import React from "react"
import { FunctionField, RaRecord } from "react-admin"

interface PriceFieldProps {
  label: string
  sourceField: "pricePerWordNewAsset" | "pricePerWordRepeatedAsset" | "pricePerWordRecycledAsset"
  shouldGrayOut?: boolean
}

export const PriceField = ({ label, sourceField, shouldGrayOut = false }: PriceFieldProps) => {
  return (
    <FunctionField
      label={label}
      source={sourceField}
      sortable={false}
      textAlign="right"
      render={(record?: RaRecord) => {
        if (!record) return "-"
        const currency = record.currency || "EUR"
        const value =
          record[sourceField] != null
            ? record[sourceField].toLocaleString(undefined, {
                style: "currency",
                currencyDisplay: 'code',
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 15
              })
            : record.price != null
            ? record.price.toLocaleString(undefined, {
                style: "currency",
                currencyDisplay: 'code',
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 15
              })
            : "-"

        const isGrayedOut = shouldGrayOut && record.type === "FIXED"
        
        return (
          <span style={{ display: "block", textAlign: "right", color: isGrayedOut ? "#999" : "inherit" }}>
            {value}
          </span>
        )
      }}
    />
  )
}

export default PriceField
